import { Tabs as MantineTabs, TabsProps } from '@mantine/core';

export type ITabsProps = TabsProps;

/** @registry Design-layer pass-through over Mantine Tabs; import this instead of @mantine/core Tabs outside src/design. Extend here when Tabs needs house behavior. Compound statics (Tabs.List, Tabs.Tab, Tabs.Panel, ...) are preserved. */
export const Tabs = MantineTabs;
